import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/IndividualUser'

const IndividualUser = {
  SyncUser(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/SyncUser`,
      data
    })
  },
   PublicPositionPageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PublicPositionPageData`,
      data
    })
  },
   MyJobApplyPageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/MyJobApplyPageData`,
      data
    })
  },
   InterestedInList(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/InterestedInList`,
      data
    })
  },
   CancelJobApply(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/CancelJobApply`,
      data
    })
  },
   JobApply(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/JobApply`,
      data
    })
  }
}

export default IndividualUser
